<template>
  <v-card flat>
    <confirmation-model
      v-if="confirmationDialog"
      :showDialog.sync="confirmationDialog"
      :openedForOperation.sync="confirmationDialogOperation"
      :text.sync="confirmationDialogConfirmationText"
      :trueText.sync="confirmationDialogTrueText"
      :falseText.sync="confirmationDialogFalseText"
      @buttonClicked="confirmationButtonClicked"
    ></confirmation-model>
    <v-container fluid>
      <v-row>
        <!-- Property Name -->
        <v-col cols="12" sm="6">
          <v-text-field
            :autocomplete="autocompleteValueLocal"
            v-model="name"
            class="to-upper"
            v-on:keydown="handleInput($event, 'alphanumeric', 255)"
            :label="$t('rentals.property_name')"
            required
            :error-messages="
              $store.state.validation && !$v.name.required
                ? [this.$t('properties.name_required')]
                : []
            "
            :outlined="is_boxes"
            :dense="is_boxes"
          ></v-text-field>
        </v-col>
        <!-- Identifier -->
        <!-- <v-col cols="12" sm="6">
          <v-text-field
            :autocomplete="autocompleteValueLocal"
            v-model="identifier"
            class="to-upper"
            v-on:keydown="handleInput($event, 'alphanumdashdot', 50)"
            :label="$t('properties.identifier')"
            :outlined="is_boxes"
            :dense="is_boxes"
          ></v-text-field>
        </v-col> -->
        <!-- Address -->
        <!-- <v-col cols="12" sm="6" class="ma-0 pa-0">
          <AddressInput
            v-model="selectedAddress"
            :list="addressesForAddressInput"
            :label="$t('address')"
            :showAddressType="false"
            :required="false"
          />
        </v-col> -->
        <!-- Property Type -->
        <v-col cols="12" sm="3">
          <v-select
            :autocomplete="autocompleteValueLocal"
            v-model="propertyType"
            :items="propertyTypes"
            item-text="text"
            item-value="id"
            :label="$t('properties.property_type')"
            append-icon="mdi-close"
            @click:append="propertyType = null"
            return-object
            :outlined="is_boxes"
            :dense="is_boxes"
            hide-no-data
          ></v-select>
        </v-col>
        <!-- Status -->
        <v-col cols="12" sm="3">
          <v-select
            :autocomplete="autocompleteValueLocal"
            v-model="status"
            :items="propertyStatuses"
            item-text="text"
            item-value="id"
            :label="$t('properties.status')"
            append-icon="mdi-close"
            @click:append="status = null"
            return-object
            :outlined="is_boxes"
            :dense="is_boxes"
            hide-no-data
          ></v-select>
        </v-col>
        <!-- Parent Property -->
        <v-col cols="12" sm="3">
          <v-autocomplete
            :autocomplete="autocompleteValueLocal"
            v-model="parentProperty"
            :items="parentProperties"
            item-value="id"
            item-text="name"
            :label="$t('properties.parent_property')"
            :search-input.sync="parentPropertySearch"
            return-object
            clearable
            :outlined="is_boxes"
            :dense="is_boxes"
            hide-no-data
            no-filter
          >
            <template slot="selection" slot-scope="{ item }">
              {{ item ? (item.name || item.identifier || '') : '' }}
            </template>
            <template slot="item" slot-scope="{ item }">
              <v-list-item-content>
                <v-list-item-title>{{ item.name || item.identifier || item.id }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
        <!-- Color -->
        <v-col cols="12" sm="3">
          <v-menu
            v-model="colorMenu"
            :close-on-content-click="false"
            offset-y
            max-width="300"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="color || '#000000'"
                :label="$t('properties.color')"
                readonly
                :outlined="is_boxes"
                :dense="is_boxes"
                v-on="on"
              >
                <template v-slot:prepend-inner>
                  <div
                    :style="{
                      width: '24px',
                      height: '24px',
                      borderRadius: '4px',
                      backgroundColor: color || '#000000',
                      border: '1px solid #ccc',
                    }"
                  />
                </template>
              </v-text-field>
            </template>
            <v-color-picker v-model="color" mode="hexa" flat />
          </v-menu>
        </v-col>
      </v-row>
      <v-row class="mt-0">
        <!-- Note -->
        <v-col cols="12" sm="12">
          <h4 class="mb-3" style="color: #9b9b9b; font-weight: normal">
            {{ $t("vehicles.note") }}
          </h4>
          <wysiwyg v-model="note" />
        </v-col>
      </v-row>
    </v-container>
    <v-btn @click="onSubmit()" id="submit-property" class="d-none"></v-btn>
    <v-btn @click="onDelete()" class="d-none" id="delete-property"></v-btn>
    <v-btn
      @click="showAttachmentDialog()"
      class="d-none"
      id="add-attachment"
    ></v-btn>
    <v-btn
      @click="exportPropertyAppointments()"
      class="d-none"
      id="export-property-appointments"
    ></v-btn>
    <attachment-dialog
      v-if="attachmentDialog"
      :showDialog.sync="attachmentDialog"
      :data="propertyId"
      :countKey="'properties'"
      :resource="'properties'"
    ></attachment-dialog>
    <v-dialog v-model="exportUrlDialog" max-width="600" persistent>
      <v-card>
        <v-card-title>{{ $t("properties.export_appointments")  }}</v-card-title>
        <v-card-text>
          <v-text-field
            :value="exportUrlValue"
            readonly
            outlined
            dense
            hide-details
          >
            <template v-slot:append>
              <v-btn icon small @click="copyText(exportUrlValue)">
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </template>
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-2" class="px-4" @click="exportUrlDialog = false">
            <v-icon dark right> mdi-keyboard-return </v-icon>
            {{ $t("nav_buttons.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import axios from "@/plugins/axios";
import { validationMixin } from "vuelidate";
import { API_BASE_URL } from "@/config";
import { ADD_MODE } from "@/config";
import { DETAILS_MODE } from "@/config";
import ConfirmationModel from "@/components/ConfirmationModel";
import AttachmentDialog from "@/components/AttachmentDialog";
// import AddressInput from "@/components/AddressInput";
import { required } from "vuelidate/lib/validators";

export default {
  name: "EditProperty",
  mixins: [validationMixin],
  components: {
    "confirmation-model": ConfirmationModel,
    "attachment-dialog": AttachmentDialog,
    // AddressInput,
  },
  validations: {
    name: {
      required,
    },
  },
  data() {
    return {
      is_boxes: this.getCompanyPropertyFromLocalStorage("boxes_on_fields", 1),
      name: "",
      identifier: "",
      note: "",
      selectedAddress: null,
      addresses: [],
      propertyType: null,
      propertyTypes: [],
      status: null,
      propertyStatuses: [],
      parentProperty: null,
      parentProperties: [],
      parentPropertySearch: "",
      parentPropertySearchTimer: null,
      color: "",
      colorMenu: false,
      isEdit: false,
      propertyId: null,
      token: this.$store.state.AccessToken,
      header: { Authorization: "Bearer " + this.$store.state.AccessToken },
      autocompleteValueLocal: "off",
      confirmationDialog: false,
      confirmationDialogConfirmationText: null,
      confirmationDialogFalseText: null,
      confirmationDialogTrueText: null,
      confirmationDialogButtonClickedIs: null,
      confirmationDialogOperation: null,
      attachmentDialog: false,
      exportUrlDialog: false,
      exportUrlValue: "",
    };
  },
  async created() {
    this.header = { Authorization: "Bearer " + this.token };
    await this.initFromRoute();
  },
  methods: {
    async initFromRoute() {
      this.isEdit = this.$route.path === "/property/edit";
      this.propertyId = this.$store.state.editId;
      if (this.isEdit) {
        this.$store.commit("setFormMode", DETAILS_MODE);
      } else {
        this.$store.commit("setFormMode", ADD_MODE);
        this.name = "";
        this.identifier = "";
        this.note = "";
        this.selectedAddress = null;
        this.propertyType = null;
        this.status = null;
        this.parentProperty = null;
        this.color = "";
      }
      this.autocompleteValueLocal = this.autocompleteValue();
      await this.fetchPropertyTypes();
      await this.fetchPropertyStatuses();
      this.fetchAddresses();
      if (this.isEdit && this.propertyId) {
        this.fetchData();
      } else if (!this.isEdit) {
        if (this.propertyTypes.length > 0) this.propertyType = this.propertyTypes[0];
        if (this.propertyStatuses.length > 0) this.status = this.propertyStatuses[0];
      }
    },
    confirmationButtonClicked(buttonClicked) {
      this.confirmationDialogButtonClickedIs = buttonClicked;
      this.confirmationDialog = false;
    },
    deletePopUp() {
      this.confirmationDialogConfirmationText = this.$t(
        "properties.delete_confirmation"
      );
      this.confirmationDialogFalseText = this.$t("nav_buttons.cancel");
      this.confirmationDialogTrueText = this.$t("nav_buttons.delete");
      this.confirmationDialogOperation = "delete";
      this.confirmationDialog = true;
    },
    onDelete() {
      this.deletePopUp();
    },
    showAttachmentDialog() {
      this.attachmentDialog = true;
    },
    createProperty(payload) {
      axios
        .post(API_BASE_URL + "/properties", payload, {
          headers: this.header,
        })
        .then(() => {
          this.$toast.success(
            this.$t("properties.property_created_successfully")
          );
          this.$router.push("/property").catch(() => {});
        })
        .catch((error) => {
          const msg =
            error?.response?.data?.errors?.[0] ||
            error?.response?.data?.message ||
            this.$t("something_went_wrong");
          this.$toast.error(msg);
        })
        .finally(() => {});
    },
    editProperty(payload) {
      const id = this.propertyId || this.$store.state.editId;
      if (!id) return;
      axios
        .put(API_BASE_URL + "/properties/" + id, payload, {
          headers: this.header,
        })
        .then(() => {
          this.$toast.success(
            this.$t("properties.property_updated_successfully")
          );
          this.$router.push("/property").catch(() => {});
        })
        .catch((error) => {
          const msg =
            error?.response?.data?.errors?.[0] ||
            error?.response?.data?.message ||
            this.$t("something_went_wrong");
          this.$toast.error(msg);
        })
        .finally(() => {});
    },
    onSubmit() {
      this.$store.commit("setValidation", true);
      if (this.$v.$invalid) {
        this.$toast.warning(this.$t("please_fill_form_correctly"));
      } else {
        if (this.isEdit) {
          this.editProperty(this.makeSubmitData());
        } else {
          this.createProperty(this.makeSubmitData());
        }
      }
    },
    makeSubmitData() {
      return {
        identifier: this.identifier || null,
        name: this.name,
        note: this.note || null,
        // address_id: this.selectedAddress ? this.selectedAddress.id : null,
        property_type_id: this.propertyType ? (this.propertyType.id ?? this.propertyType.value) : null,
        status_id: this.status ? (this.status.id ?? this.status.value) : null,
        parent_property_id: this.parentProperty ? this.parentProperty.id : null,
        color: this.color ? String(this.color).replace(/^#/, '') || null : null,
      };
    },
    fetchAddresses() {
      const url = API_BASE_URL + "/addresses?items_per_page=50";
      axios.get(url, { headers: this.header })
        .then(({ data }) => {
          const list = data.data || data || [];
          this.addresses = Array.isArray(list) ? list : [];
        })
        .catch(() => {});
    },
    async fetchPropertyTypes() {
      try {
        const data = await this.getCodes("property_types", "properties.types");
        this.propertyTypes = data || [];
      } catch {
        this.propertyTypes = [];
      }
    },
    async fetchPropertyStatuses() {
      try {
        let data = await this.getCodes("property_status", "properties.statuses");
        if (!data || (Array.isArray(data) && data.length === 0)) {
          data = await this.getCodes("property_statuses", "properties.statuses");
        }
        this.propertyStatuses = Array.isArray(data) ? data : [];
      } catch {
        this.propertyStatuses = [];
      }
    },
    fetchParentProperties() {
      const search = this.parentPropertySearch && typeof this.parentPropertySearch === "string" ? this.parentPropertySearch : "";
      const url = API_BASE_URL + "/properties?items_per_page=50" + (search ? "&search=" + encodeURIComponent(search) : "");
      axios.get(url, { headers: this.header })
        .then(({ data }) => {
          const list = data.data || data || [];
          this.parentProperties = list.filter((p) => p.id !== this.propertyId);
        })
        .catch(() => {});
    },
    fetchData() {
      const id = this.propertyId || this.$store.state.editId;
      if (!id) return;
      axios
        .get(API_BASE_URL + "/properties/" + id, {
          headers: this.header,
        })
        .then((res) => {
          const raw = res.data;
          const data = raw?.data || raw;
          this.$store.commit("setCurrentPageData", data);
          this.name = data.name || "";
          this.identifier = data.identifier || "";
          this.note = data.note || "";
          this.color = data.color ? "#" + String(data.color) : "";
          if (data.address && typeof data.address === "object") {
            this.selectedAddress = { ...data.address, id: data.address_id || data.address.id };
            if (!this.addresses.some((a) => (a.id || a.address?.id) === this.selectedAddress.id)) {
              this.addresses.unshift(this.selectedAddress);
            }
          } else if (data.address_id != null) {
            this.selectedAddress = { id: data.address_id };
          } else {
            this.selectedAddress = null;
          }
          const typeId = data.property_type_id;
          const statusId = data.status_id;
          this.propertyType = this.propertyTypes.find((t) => t.id === typeId || t.value === typeId) || null;
          this.status = this.propertyStatuses.find((s) => s.id === statusId || s.value === statusId) || null;
          this.parentProperty = data.parent_property || (data.parent_property_id ? { id: data.parent_property_id } : null);
          if (data.parent_property && typeof data.parent_property === "object") {
            this.parentProperty = data.parent_property;
          }
          this.fetchAddresses();
          this.fetchParentProperties();
        })
        .catch(() => {
          this.$toast.error(this.$t("something_went_wrong"));
        });
    },
    deleteProperty() {
      const id = this.propertyId || this.$store.state.editId;
      if (!id) return;
      axios
        .delete(API_BASE_URL + "/properties/" + id, {
          headers: this.header,
        })
        .then(() => {
          this.$toast.success(this.$t("properties.property_deleted_successfully"));
          this.$router.push("/property").catch(() => {});
        })
        .catch((error) => {
          const msg =
            error?.response?.data?.errors?.[0] ||
            error?.response?.data?.message ||
            this.$t("something_went_wrong");
          this.$toast.error(msg);
        })
        .finally(() => {});
    },
    exportPropertyAppointments() {
      const propertyId = this.$store.state.editId;
      if (!propertyId) {
        this.$toast.error(this.$t("something_went_wrong"));
        return;
      }
      console.log('propertyId', propertyId, "/properties/" + this.encryptToMD5(String(propertyId)) + "/appointments");
      const apiPath = API_BASE_URL + "/properties/" + this.encryptToMD5(String(propertyId)) + "/appointments";
      this.exportUrlValue =
        apiPath.startsWith("http") ? apiPath : (window.location?.origin || "") + apiPath;
      this.exportUrlDialog = true;
    },
  },
  computed: {
    addressesForAddressInput() {
      return this.addresses.map((a) => ({ address: a.address || a }));
    },
  },
  watch: {
    "$route.path"() {
      this.initFromRoute();
    },
    parentPropertySearch(val) {
      if (typeof val !== "string") return;
      clearTimeout(this.parentPropertySearchTimer);
      this.parentPropertySearchTimer = setTimeout(() => this.fetchParentProperties(), 400);
    },
    confirmationDialogButtonClickedIs(newVal) {
      if (newVal === true && this.confirmationDialogOperation != null) {
        if (
          this.confirmationDialogOperation === "delete" &&
          this.confirmationDialogButtonClickedIs === true
        ) {
          this.deleteProperty();
        }
        this.confirmationDialogButtonClickedIs = null;
      }
    },
  },
};
</script>
<style scoped></style>
